<script lang="ts">
  // The field this column represents
  export let column: string;

  // The display text for this column header
  export let label: string;

  // The field currently being used to sort the entire table
  export let sortField: string;

  // The current sort direction ('asc' or 'desc') for the active sort field
  export let sortDirection: "asc" | "desc";

  // Callback function to handle sorting when this header is clicked
  export let onSort: (column: string, direction: "asc" | "desc") => void;

  /**
   * Handles clicking the up arrow (ascending sort)
   * @param event - The mouse or keyboard event
   */
  function handleUpClick(event: MouseEvent | KeyboardEvent) {
    event.stopPropagation();
    if (sortField === column && sortDirection === "asc") return;
    onSort(column, "asc");
  }

  /**
   * Handles clicking the down arrow (descending sort)
   * @param event - The mouse or keyboard event
   */
  function handleDownClick(event: MouseEvent | KeyboardEvent) {
    event.stopPropagation();
    if (sortField === column && sortDirection === "desc") return;
    onSort(column, "desc");
  }

  function handleHeaderClick() {
    // Default behavior when clicking the header: toggle direction if already sorting by this column,
    // otherwise default to ascending
    if (sortField === column) {
      onSort(column, sortDirection === "asc" ? "desc" : "asc");
    } else {
      onSort(column, "desc");
    }
  }
</script>

<div class="text-xs font-medium text-gray-500 title-case tracking-wider cursor-pointer select-none">
  <div class="flex items-center justify-between gap-3">
    {label}
    <div class="flex flex-col">
      <!-- Up arrow (ascending) -->
      <button
        type="button"
        class="text-[12px] leading-none pb-[2px] {sortField === column && sortDirection === 'asc'
          ? 'text-gray-700'
          : 'text-gray-300'}"
        onclick={handleUpClick}
        onkeydown={(e) => e.key === "Enter" && handleUpClick(e)}
        aria-label="Sort {label} ascending"
      >
        ▲
      </button>
      <!-- Down arrow (descending) -->
      <button
        type="button"
        class="text-[12px] leading-none pt-[2px] {sortField === column && sortDirection === 'desc'
          ? 'text-gray-700'
          : 'text-gray-300'}"
        onclick={handleDownClick}
        onkeydown={(e) => e.key === "Enter" && handleDownClick(e)}
        aria-label="Sort {label} descending"
      >
        ▼
      </button>
    </div>
  </div>
</div>
